import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const BUCKETS = [
  { key: "current", label: "Current" },
  { key: "d1_30", label: "1–30" },
  { key: "d31_60", label: "31–60" },
  { key: "d61_90", label: "61–90" },
  { key: "d90_plus", label: "90+" },
] as const;

/** Recharts to-collect aging — plan/50 + plan/26. */
export function AgingBarChart(props: {
  aging: Record<(typeof BUCKETS)[number]["key"], string>;
  currencyCode: string;
  height?: number;
  compact?: boolean;
}) {
  const data = BUCKETS.map((b) => ({
    label: b.label,
    amount: Number(props.aging[b.key]) || 0,
  }));
  const height = props.height ?? (props.compact ? 72 : 180);
  return (
    <div style={{ width: "100%", height }} className="min-w-0">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={
            props.compact
              ? { top: 4, right: 4, left: 0, bottom: 0 }
              : { top: 8, right: 8, left: 0, bottom: 0 }
          }
        >
          <XAxis
            dataKey="label"
            tickLine={false}
            axisLine={false}
            tick={{ fontSize: 11, fill: "var(--color-muted)" }}
            hide={props.compact}
          />
          {!props.compact ? (
            <YAxis
              width={44}
              tickLine={false}
              axisLine={false}
              tick={{ fontSize: 11, fill: "var(--color-muted)" }}
              tickFormatter={(v) =>
                new Intl.NumberFormat("en-PH", {
                  notation: "compact",
                  maximumFractionDigits: 0,
                }).format(Number(v) || 0)
              }
            />
          ) : null}
          <Tooltip
            contentStyle={{
              borderRadius: 8,
              border: "1px solid var(--color-border)",
              background: "var(--color-card)",
              fontSize: 12,
            }}
            formatter={(value) => [
              new Intl.NumberFormat("en-PH", {
                style: "currency",
                currency: props.currencyCode,
                maximumFractionDigits: 0,
              }).format(Number(value) || 0),
              "Open",
            ]}
          />
          <Bar
            dataKey="amount"
            fill="var(--color-primary)"
            radius={[4, 4, 0, 0]}
            maxBarSize={props.compact ? 16 : 36}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
